/**
 * Lightweight i18n dictionaries (EN/ES/FR/DE/TL/PT) for key public-page
 * strings. Coverage: Homepage hero/nav/stats, Schools landing hero/pricing.
 * AvA chat is already multilingual via avatar_config.language.
 */
import { HOME_TRANSLATIONS } from './homeTranslations';
import { REG_TRANSLATIONS } from './regTranslations';

export const TRANSLATIONS = {
  en: {
    'nav.home': 'Home',
    'nav.how': 'How It Works',
    'nav.why': 'Why HiBFF',
    'nav.safety': 'Safety',
    'nav.pricing': 'Pricing',
    'nav.about': 'About',
    'nav.schools': 'Education', 'nav.family': 'Teens & Parents', 'nav.adults': 'Adults',
    'nav.newsletter': 'Newsletter',
    'nav.login': 'Log In',
    'nav.getStarted': 'Start Practising Free',
    'hero.pre': 'Practice social skills. With AI that feels real.',
    'hero.h1a': 'The world changed after Covid.',
    'hero.h1b': "We're giving it back. One conversation at a time.",
    'hero.sub': 'An entire generation lost the years when social confidence forms naturally. Practice real conversations with AI that feels human. Safe. Private. Free to start.',
    'hero.cta': 'Start Practising Free',
    'hero.choosePath': 'Choose your path',
    'hero.iam': 'I am a',
    'hero.teen': 'Teen / Parent',
    'hero.adult': 'Adult Professional',
    'stats.n1': 'Worldwide',
    'stats.l1': 'Available globally — everyone, everywhere',
    'stats.n2': 'Personalised',
    'stats.l2': 'AI partner that adapts to you',
    'stats.n3': 'Real Skills',
    'stats.l3': 'Confidence built challenge by challenge',
    'stats.n4': 'Safe by Design',
    'stats.l4': 'GDPR · UK-AADC · SOC 2 ready · 13+',
    'pricing.billedUsd': 'billed in GBP',
    'schools.onerate': 'Simple, transparent pricing. One rate. Worldwide.',
    'schools.quote': '“Brave takes courage. Courage builds confidence. Courage builds character. And character is the foundation of friends forever.”',
    'schools.p1': 'That is not just our tagline — it is our reason for existing. HiBFF is a safe place where teenagers build the courage to step into the real world, one conversation, one challenge, one moment of bravery at a time. Guided by AI practice partners called AvAs, teens rehearse the moments that matter — small talk before a party, a difficult conversation with a teacher, the confidence to say something kind to a stranger. All in a private space they control.',
    'schools.p2': 'It is not therapy. It is not a mental health app. It is practice — so when real life calls, they are ready to answer.',
    'schools.simplePricing': 'Simple Pricing',
    'schools.perStudent': 'per student, per month',
  },
  es: {
    'nav.home': 'Inicio',
    'nav.how': 'Cómo funciona',
    'nav.why': 'Por qué HiBFF',
    'nav.safety': 'Seguridad',
    'nav.pricing': 'Precios',
    'nav.about': 'Nosotros',
    'nav.schools': 'Educación', 'nav.family': 'Adolescentes y padres', 'nav.adults': 'Adultos',
    'nav.newsletter': 'Boletín',
    'nav.login': 'Iniciar sesión',
    'nav.getStarted': 'Empieza gratis',
    'hero.h1a': 'Practica habilidades sociales.',
    'hero.h1b': 'Con una IA que se siente real.',
    'hero.sub': 'Un espacio seguro de práctica para adolescentes. Un compañero de desarrollo incansable para adultos. Ensaya las conversaciones que importan — antes de que ocurran en la vida real.',
    'hero.cta': 'Empieza a practicar gratis',
    'hero.choosePath': 'Elige tu camino',
    'hero.iam': 'Soy',
    'hero.teen': 'Adolescente / Padre',
    'hero.adult': 'Profesional adulto',
    'stats.n1': 'Mundial',
    'stats.l1': 'Disponible globalmente — para todos, en todas partes',
    'stats.n2': 'Personalizado',
    'stats.l2': 'Un compañero de IA que se adapta a ti',
    'stats.n3': 'Habilidades reales',
    'stats.l3': 'Confianza construida reto a reto',
    'stats.n4': 'Seguro por diseño',
    'stats.l4': 'GDPR · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'facturado en GBP',
    'schools.onerate': 'Precios simples y transparentes. Una tarifa. En todo el mundo.',
    'schools.quote': '“Ser valiente requiere coraje. El coraje construye confianza. El coraje construye carácter. Y el carácter es la base de las amistades para siempre.”',
    'schools.p1': 'No es solo nuestro lema: es nuestra razón de existir. HiBFF es un lugar seguro donde los adolescentes desarrollan el coraje para salir al mundo real, una conversación, un reto, un momento de valentía a la vez. Guiados por compañeros de práctica con IA llamados AvAs, los adolescentes ensayan los momentos que importan: una charla antes de una fiesta, una conversación difícil con un profesor, la confianza para decir algo amable a un desconocido. Todo en un espacio privado que ellos controlan.',
    'schools.p2': 'No es terapia. No es una app de salud mental. Es práctica — para que cuando la vida real llame, estén listos para responder.',
    'schools.simplePricing': 'Precios simples',
    'schools.perStudent': 'por estudiante, al mes',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.how': 'Comment ça marche',
    'nav.why': 'Pourquoi HiBFF',
    'nav.safety': 'Sécurité',
    'nav.pricing': 'Tarifs',
    'nav.about': 'À propos',
    'nav.schools': 'Éducation', 'nav.family': 'Ados et parents', 'nav.adults': 'Adultes',
    'nav.newsletter': 'Newsletter',
    'nav.login': 'Se connecter',
    'nav.getStarted': 'Commencer gratuitement',
    'hero.h1a': 'Entraîne tes compétences sociales.',
    'hero.h1b': 'Avec une IA qui semble réelle.',
    'hero.sub': "Un espace d'entraînement sûr pour les ados. Un partenaire de développement infatigable pour les adultes. Répète les conversations qui comptent — avant qu'elles n'arrivent dans la vraie vie.",
    'hero.cta': 'Commencer gratuitement',
    'hero.choosePath': 'Choisis ton parcours',
    'hero.iam': 'Je suis',
    'hero.teen': 'Ado / Parent',
    'hero.adult': 'Professionnel adulte',
    'stats.n1': 'Mondial',
    'stats.l1': 'Disponible partout — pour tous, partout',
    'stats.n2': 'Personnalisé',
    'stats.l2': "Un partenaire IA qui s'adapte à toi",
    'stats.n3': 'Compétences réelles',
    'stats.l3': 'La confiance se construit défi après défi',
    'stats.n4': 'Sûr par conception',
    'stats.l4': 'RGPD · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'facturé en GBP',
    'schools.onerate': 'Une tarification simple et transparente. Un seul tarif. Partout dans le monde.',
    'schools.quote': '“Être brave demande du courage. Le courage construit la confiance. Le courage forge le caractère. Et le caractère est le fondement des amitiés pour toujours.”',
    'schools.p1': "Ce n'est pas seulement notre devise — c'est notre raison d'exister. HiBFF est un lieu sûr où les adolescents développent le courage d'affronter le monde réel, une conversation, un défi, un moment de bravoure à la fois. Guidés par des partenaires d'entraînement IA appelés AvAs, les ados répètent les moments qui comptent : une discussion avant une fête, une conversation difficile avec un professeur, la confiance de dire un mot gentil à un inconnu. Le tout dans un espace privé qu'ils contrôlent.",
    'schools.p2': "Ce n'est pas une thérapie. Ce n'est pas une app de santé mentale. C'est de l'entraînement — pour que, quand la vraie vie appelle, ils soient prêts à répondre.",
    'schools.simplePricing': 'Tarification simple',
    'schools.perStudent': 'par élève, par mois',
  },
  de: {
    'nav.home': 'Start',
    'nav.how': "So funktioniert's",
    'nav.why': 'Warum HiBFF',
    'nav.safety': 'Sicherheit',
    'nav.pricing': 'Preise',
    'nav.about': 'Über uns',
    'nav.schools': 'Bildung', 'nav.family': 'Teens & Eltern', 'nav.adults': 'Erwachsene',
    'nav.newsletter': 'Newsletter',
    'nav.login': 'Anmelden',
    'nav.getStarted': 'Kostenlos starten',
    'hero.h1a': 'Trainiere soziale Fähigkeiten.',
    'hero.h1b': 'Mit KI, die sich echt anfühlt.',
    'hero.sub': 'Ein sicherer Übungsraum für Teens. Ein unermüdlicher Entwicklungspartner für Erwachsene. Übe die Gespräche, die zählen — bevor sie im echten Leben stattfinden.',
    'hero.cta': 'Kostenlos üben',
    'hero.choosePath': 'Wähle deinen Weg',
    'hero.iam': 'Ich bin',
    'hero.teen': 'Teen / Eltern',
    'hero.adult': 'Berufstätige:r',
    'stats.n1': 'Weltweit',
    'stats.l1': 'Überall verfügbar — für alle, überall',
    'stats.n2': 'Personalisiert',
    'stats.l2': 'Ein KI-Partner, der sich dir anpasst',
    'stats.n3': 'Echte Fähigkeiten',
    'stats.l3': 'Selbstvertrauen, Challenge für Challenge',
    'stats.n4': 'Sicher konzipiert',
    'stats.l4': 'DSGVO · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'Abrechnung in GBP',
    'schools.onerate': 'Einfache, transparente Preise. Ein Tarif. Weltweit.',
    'schools.quote': '“Mut braucht Überwindung. Mut schafft Selbstvertrauen. Mut formt Charakter. Und Charakter ist das Fundament von Freundschaften fürs Leben.”',
    'schools.p1': 'Das ist nicht nur unser Slogan — es ist unser Grund zu existieren. HiBFF ist ein sicherer Ort, an dem Jugendliche den Mut entwickeln, in die reale Welt hinauszugehen — ein Gespräch, eine Challenge, ein mutiger Moment nach dem anderen. Begleitet von KI-Übungspartnern namens AvAs proben Teens die Momente, die zählen: Smalltalk vor einer Party, ein schwieriges Gespräch mit einer Lehrkraft, der Mut, einem Fremden etwas Nettes zu sagen. Alles in einem privaten Raum, den sie selbst kontrollieren.',
    'schools.p2': 'Es ist keine Therapie. Es ist keine Mental-Health-App. Es ist Training — damit sie bereit sind, wenn das echte Leben ruft.',
    'schools.simplePricing': 'Einfache Preise',
    'schools.perStudent': 'pro Schüler:in, pro Monat',
  },
  tl: {
    'nav.home': 'Home',
    'nav.how': 'Paano Ito Gumagana',
    'nav.why': 'Bakit HiBFF',
    'nav.safety': 'Kaligtasan',
    'nav.pricing': 'Presyo',
    'nav.about': 'Tungkol Sa Amin',
    'nav.schools': 'Edukasyon', 'nav.family': 'Teens at Magulang', 'nav.adults': 'Adults',
    'nav.newsletter': 'Newsletter',
    'nav.login': 'Mag-log In',
    'nav.getStarted': 'Magsimula nang Libre',
    'hero.h1a': 'Sanayin ang social skills.',
    'hero.h1b': 'Kasama ang AI na parang totoo.',
    'hero.sub': 'Isang ligtas na espasyo ng pagsasanay para sa mga teenager. Isang walang-sawang kasama sa pag-unlad para sa mga adult. Ensayuhin ang mga usapang mahalaga — bago pa ito mangyari sa totoong buhay.',
    'hero.cta': 'Magsimulang Magsanay nang Libre',
    'hero.choosePath': 'Piliin ang iyong landas',
    'hero.iam': 'Ako ay',
    'hero.teen': 'Teen / Magulang',
    'hero.adult': 'Adult na Propesyonal',
    'stats.n1': 'Pandaigdigan',
    'stats.l1': 'Available sa buong mundo — para sa lahat, saanman',
    'stats.n2': 'Personalisado',
    'stats.l2': 'AI partner na umaangkop sa iyo',
    'stats.n3': 'Tunay na Kakayahan',
    'stats.l3': 'Kumpiyansang itinatayo sa bawat hamon',
    'stats.n4': 'Ligtas ang Disenyo',
    'stats.l4': 'GDPR · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'sinisingil sa GBP',
    'schools.onerate': 'Simple at malinaw na presyo. Isang rate. Sa buong mundo.',
    'schools.quote': '“Ang tapang ay nangangailangan ng lakas ng loob. Ang lakas ng loob ay bumubuo ng kumpiyansa. Ang lakas ng loob ay humuhubog ng karakter. At ang karakter ang pundasyon ng magkaibigan magpakailanman.”',
    'schools.p1': 'Hindi lang ito ang aming tagline — ito ang dahilan ng aming pag-iral. Ang HiBFF ay isang ligtas na lugar kung saan ang mga teenager ay nagkakaroon ng lakas ng loob na humarap sa totoong mundo — isang usapan, isang hamon, isang matapang na sandali sa bawat pagkakataon. Sa gabay ng mga AI practice partner na tinatawag na AvAs, ineensayo ng mga teen ang mga sandaling mahalaga: small talk bago ang party, mahirap na usapan sa guro, at ang kumpiyansang magsabi ng mabait sa isang estranghero. Lahat sa isang pribadong espasyong sila ang may kontrol.',
    'schools.p2': 'Hindi ito therapy. Hindi ito mental health app. Ito ay pagsasanay — para kapag tumawag ang totoong buhay, handa silang sumagot.',
    'schools.simplePricing': 'Simpleng Presyo',
    'schools.perStudent': 'bawat estudyante, bawat buwan',
  },
  pt: {
    'nav.home': 'Início',
    'nav.how': 'Como Funciona',
    'nav.why': 'Por que HiBFF',
    'nav.safety': 'Segurança',
    'nav.pricing': 'Preços',
    'nav.about': 'Sobre nós',
    'nav.schools': 'Educação', 'nav.family': 'Adolescentes e pais', 'nav.adults': 'Adultos',
    'nav.newsletter': 'Newsletter',
    'nav.login': 'Entrar',
    'nav.getStarted': 'Comece grátis',
    'hero.h1a': 'Pratique habilidades sociais.',
    'hero.h1b': 'Com uma IA que parece real.',
    'hero.sub': 'Um espaço seguro de prática para adolescentes. Um parceiro de desenvolvimento incansável para adultos. Ensaie as conversas que importam — antes que aconteçam na vida real.',
    'hero.cta': 'Comece a praticar grátis',
    'hero.choosePath': 'Escolha seu caminho',
    'hero.iam': 'Eu sou',
    'hero.teen': 'Adolescente / Responsável',
    'hero.adult': 'Profissional adulto',
    'stats.n1': 'Mundial',
    'stats.l1': 'Disponível globalmente — para todos, em todo lugar',
    'stats.n2': 'Personalizado',
    'stats.l2': 'Um parceiro de IA que se adapta a você',
    'stats.n3': 'Habilidades reais',
    'stats.l3': 'Confiança construída desafio a desafio',
    'stats.n4': 'Seguro por design',
    'stats.l4': 'GDPR · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'cobrado em GBP',
    'schools.onerate': 'Preços simples e transparentes. Uma tarifa. No mundo inteiro.',
    'schools.quote': '“Ser corajoso exige coragem. A coragem constrói confiança. A coragem constrói caráter. E o caráter é a base de amizades para sempre.”',
    'schools.p1': 'Isso não é apenas nosso slogan — é nossa razão de existir. O HiBFF é um lugar seguro onde adolescentes desenvolvem a coragem de encarar o mundo real, uma conversa, um desafio, um momento de bravura de cada vez. Guiados por parceiros de prática com IA chamados AvAs, os adolescentes ensaiam os momentos que importam: uma conversa antes de uma festa, um diálogo difícil com um professor, a confiança de dizer algo gentil a um desconhecido. Tudo em um espaço privado que eles controlam.',
    'schools.p2': 'Não é terapia. Não é um app de saúde mental. É prática — para que, quando a vida real chamar, eles estejam prontos para responder.',
    'schools.simplePricing': 'Preços simples',
    'schools.perStudent': 'por aluno, por mês',
  },
  ar: {
    'nav.home': 'الرئيسية',
    'nav.how': 'كيف يعمل',
    'nav.why': 'لماذا HiBFF',
    'nav.safety': 'الأمان',
    'nav.pricing': 'الأسعار',
    'nav.about': 'من نحن',
    'nav.schools': 'التعليم', 'nav.family': 'المراهقون والآباء', 'nav.adults': 'البالغون',
    'nav.newsletter': 'النشرة البريدية',
    'nav.login': 'تسجيل الدخول',
    'nav.getStarted': 'ابدأ مجانًا',
    'hero.h1a': 'تدرّب على المهارات الاجتماعية.',
    'hero.h1b': 'مع ذكاء اصطناعي يبدو حقيقيًا.',
    'hero.sub': 'مساحة تدريب آمنة للمراهقين. شريك تطوير لا يكلّ للبالغين. تدرّب على المحادثات المهمة — قبل أن تحدث في الحياة الواقعية.',
    'hero.cta': 'ابدأ التدريب مجانًا',
    'hero.choosePath': 'اختر مسارك',
    'hero.iam': 'أنا',
    'hero.teen': 'مراهق / ولي أمر',
    'hero.adult': 'محترف بالغ',
    'stats.n1': 'عالمي',
    'stats.l1': 'متاح عالميًا — للجميع، في كل مكان',
    'stats.n2': 'مخصص',
    'stats.l2': 'شريك ذكاء اصطناعي يتكيف معك',
    'stats.n3': 'مهارات حقيقية',
    'stats.l3': 'ثقة تُبنى تحديًا بعد تحدٍّ',
    'stats.n4': 'آمن بالتصميم',
    'stats.l4': 'GDPR · UK-AADC · SOC 2 · 13+',
    'pricing.billedUsd': 'تُدفع بالدولار الأمريكي',
    'schools.onerate': 'أسعار بسيطة وشفافة. سعر واحد. حول العالم.',
    'schools.quote': '"الشجاعة تتطلب جرأة. الجرأة تبني الثقة. الجرأة تبني الشخصية. والشخصية هي أساس الصداقات الدائمة."',
    'schools.p1': 'هذا ليس مجرد شعارنا — إنه سبب وجودنا. HiBFF هو مكان آمن يبني فيه المراهقون الشجاعة لخوض العالم الحقيقي، محادثة واحدة، تحدٍّ واحد، لحظة شجاعة واحدة في كل مرة. بإرشاد شركاء تدريب بالذكاء الاصطناعي يُدعون AvAs، يتدرب المراهقون على اللحظات المهمة: حديث قصير قبل حفلة، محادثة صعبة مع معلم، والثقة لقول شيء لطيف لشخص غريب. كل ذلك في مساحة خاصة يتحكمون بها.',
    'schools.p2': 'ليس علاجًا. وليس تطبيقًا للصحة النفسية. إنه تدريب — حتى عندما تنادي الحياة الحقيقية، يكونون مستعدين للإجابة.',
    'schools.simplePricing': 'أسعار بسيطة',
    'schools.perStudent': 'لكل طالب، شهريًا',
  },
};

Object.keys(TRANSLATIONS).forEach((l) => Object.assign(TRANSLATIONS[l], HOME_TRANSLATIONS[l] || {}, REG_TRANSLATIONS[l] || {}));
